<div class="relative max-w-2xl p-5 mx-auto bg-white rounded-md shadow-lg pb-7">
  @if (agencyName) {
    <h2>
      <strong>{{ agencyName }}</strong> has added you as a user to their agency.
    </h2>
    <h3>Please confirm your email address</h3>
    <p class="mt-4">You should have received an email to the address entered by the representative at {{ agencyName }}. Please click the link to confirm that you have access to that email and your sign-up process will be complete.</p>
  }
  @if (!agencyName) {
    <h2>Thank you for signing up for QualityBidders!</h2>
    <h3>Please confirm your email address</h3>
    <p class="mt-4">You should have received an email to the address you entered when you signed up. Please click the link to confirm that you have access to that email and your sign-up process will be complete.</p>
  }

  <!-- <form *ngIf="form" [formGroup]="form">
  <div class="grid grid-cols-1 gap-x-4 sm:grid-cols-2">
    <mat-form-field>
      <mat-label>First Name</mat-label>
      <input
        matInput
        type="text"
        class=""
        formControlName="firstName"
        required
        />
      <mat-error *ngIf="form.controls.firstName.errors?.required">
        Please enter a first name
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Last Name</mat-label>
      <input
        matInput
        type="text"
        class=""
        formControlName="lastName"
        required
        />
      <mat-error *ngIf="form.controls.lastName.errors?.required">
        Please enter a last name
      </mat-error>
    </mat-form-field>
  </div>
  <mat-form-field class="w-full">
    <mat-label>Email</mat-label>
    <input
      matInput
      type="text"
      class=""
      formControlName="email"
      autocomplete="email"
      required
      />
    <mat-error *ngIf="form.controls.email.errors?.required">
      Please enter the email address that you will use to log in
    </mat-error>
    <mat-error *ngIf="form.controls.email.errors?.email">
      This field must be a valid email address
    </mat-error>
  </mat-form-field>

  <div class="grid grid-cols-1 gap-x-4 sm:grid-cols-2 mb-2">
    <mat-form-field>
      <mat-label>Phone</mat-label>
      <input
        matInput
        type="text"
        class=""
        formControlName="phone"
        mask="(000) 000-0000"
        required
        />
      <mat-error *ngIf="form.controls.phone.errors?.required">
        Please enter a phone number that can be used to contact you
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Ext</mat-label>
      <input
        matInput
        type="text"
        class=""
        formControlName="extension"
        mask="9999999999"
        [specialCharacters]="[]"
        [validation]="false"
        />
    </mat-form-field>
  </div>
  <mat-form-field class="w-full" *ngIf="form.controls.companyName">
    <mat-label>Company Name</mat-label>
    <input
      matInput
      type="text"
      class=""
      formControlName="companyName"
      required
      />
    <mat-error *ngIf="form.controls.companyName.errors?.required">
      Please enter your company's name
    </mat-error>
  </mat-form-field>
  <p>
    <mat-checkbox formControlName="confirmPolicy"
      >I have read, understand and agree to the
      <a
        class="link"
        href="/privacy-policy"
        target="_blank"
        aria-label="Read about privacy policy"
        >Privacy Statement</a
        >
        for use of this Secure Bids website.</mat-checkbox
        >
      </p>
      <p
        class="text-danger"
        *ngIf="form.controls.confirmPolicy.errors?.required && submitted"
        >
        <small>You must agree to the Secure Bids Privacy Statement</small>
      </p>
      <p>
        <mat-checkbox formControlName="liabilityRelease"
          >I have read, understand and agree to the Secure Bids
          <a
            class="link"
            href="/release-of-liability"
            target="_blank"
            aria-label="Read about release of liability"
            >
            Release of Liability</a
            >.</mat-checkbox
            >
          </p>
          <p
            class="text-danger"
            *ngIf="form.controls.liabilityRelease.errors?.required && submitted"
            >
            <small>
              You must agree to the Secure Bids Release of Liability Statement
            </small>
          </p>
          <div><small>* Required fields</small></div>
          <div class="pt-3">
            <button
              mat-raised-button
              color="primary"
              (click)="submit()"
              aria-label="Create New Account"
              aria-labelledby="Create New Account"
              >
              Create New Account
            </button>
          </div>
        </form> -->
</div>
